"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var Validation_1 = __importDefault(require("../../../../../Validation"));
var react_i18next_1 = require("react-i18next");
var BlDateTime_1 = __importDefault(require("../../../../../FormComponents/BlDateTime"));
var ProjectsName_1 = __importDefault(require("../ProjectsName"));
var FileUploadSection_1 = __importDefault(require("../FileUploadSection"));
var classnames_1 = __importDefault(require("classnames"));
var styles_module_scss_1 = __importDefault(require("../../../styles.module.scss"));
var DeveloperProjects = function (_a) {
    var _b;
    var formikProps = _a.formikProps;
    var t = react_i18next_1.useTranslation('common').t;
    return (react_1.default.createElement("div", { className: styles_module_scss_1.default.section },
        react_1.default.createElement("div", { className: classnames_1.default(styles_module_scss_1.default.section_content, 'ui grid stackable') },
            react_1.default.createElement("div", { className: classnames_1.default(styles_module_scss_1.default.row, 'sixteen wide computer column') },
                react_1.default.createElement("div", { className: classnames_1.default('sixteen wide mobile sixteen wide tablet sixteen wide computer column', styles_module_scss_1.default.section_field) },
                    react_1.default.createElement("label", { className: styles_module_scss_1.default.label_inputs, htmlFor: "dateOfEstablishment" },
                        react_1.default.createElement("p", null, t('Account.Settings.DATE_OF_ESTABLISHMENT')),
                        react_1.default.createElement(Validation_1.default, { name: "dateOfEstablishment", formikProps: formikProps },
                            react_1.default.createElement("div", null,
                                react_1.default.createElement(BlDateTime_1.default, { selected: formikProps.values
                                        .dateOfEstablishment
                                        ? new Date(formikProps.values.dateOfEstablishment)
                                        : null, onChange: function (value) {
                                        return formikProps.setFieldValue('dateOfEstablishment', value);
                                    } })))))),
            !!((_b = formikProps.values.projects) === null || _b === void 0 ? void 0 : _b.length) && (react_1.default.createElement(ProjectsName_1.default, { formikProps: formikProps })),
            react_1.default.createElement(FileUploadSection_1.default, { formikProps: formikProps }))));
};
exports.default = DeveloperProjects;
